import { render, staticRenderFns } from "./searchInsured.vue?vue&type=template&id=326e923c&scoped=true&"
import script from "./searchInsured.vue?vue&type=script&lang=js&"
export * from "./searchInsured.vue?vue&type=script&lang=js&"
import style0 from "./searchInsured.vue?vue&type=style&index=0&id=326e923c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326e923c",
  null
  
)

export default component.exports